import { HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import * as i2 from '@upr-web-primer/locale';
import { LocaleModule } from '@upr-web-primer/locale';
import * as i1 from '@upr-web-primer/tcm-service';
import { get, merge } from 'lodash-es';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, first } from 'rxjs/operators';

class PageLabelsModule {
}
PageLabelsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PageLabelsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PageLabelsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PageLabelsModule, imports: [HttpClientModule, LocaleModule] });
PageLabelsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PageLabelsModule, imports: [[HttpClientModule, LocaleModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PageLabelsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [HttpClientModule, LocaleModule]
                }]
        }] });

const PageLabelsUrls = {
    GET_PAGE_LABELS: '/%language%/%country%/api/pageinfo.html',
};

class PageLabelsResolver {
    constructor(tridion, locale, iceDataUrl) {
        this.tridion = tridion;
        this.locale = locale;
        this.iceDataUrl = iceDataUrl;
        this.$pageLabels = new BehaviorSubject(undefined);
        this.subscriptions = new Subscription();
        const publication = this.tridion.tridionEnvConfig.publication;
        let url = PageLabelsUrls.GET_PAGE_LABELS;
        if (this.tridion.tridionEnvConfig.dynamic_path_enabled) {
            this.subscriptions.add(this.tridion.siteConfig$.subscribe((config) => {
                if (config?.tridion_pub) {
                    url = config.tridion_pub + url;
                }
                else {
                    url = publication + url;
                }
                this.pageInfoUrl = url;
            }));
        }
        else {
            this.pageInfoUrl = publication + url;
        }
    }
    get() {
        return this.$pageLabels.pipe(filter(Boolean), first()).toPromise();
    }
    resolve() {
        return this.get().then((pageLabels) => pageLabels);
    }
    init() {
        this.getData();
    }
    getData() {
        const locale = this.locale.getFromStorage();
        const dataUrl = (this.iceDataUrl || '')
            .replace('%language%', locale.language)
            .replace('%country%', locale.country);
        const pageInfoUrl = (this.pageInfoUrl || '')
            .replace('%language%', locale.language)
            .replace('%country%', locale.country);
        const calls = [];
        if (pageInfoUrl) {
            calls.push(this.tridion.request(pageInfoUrl));
        }
        if (dataUrl) {
            calls.push(this.tridion.request(dataUrl));
        }
        return Promise.all(calls)
            .then((data) => {
            const firstObj = get(data, '0.ResourceList')
                ? merge(get(data, '0.ResourceList', {}), get(data, '0.AttractionLocationImages', {}))
                : get(data, '0', {});
            this.$pageLabels.next(merge(get(data, '1', {}), firstObj));
        })
            .catch((error) => {
            console.error(error);
            this.$pageLabels.next({});
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
PageLabelsResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PageLabelsResolver, deps: [{ token: i1.TcmService }, { token: i2.LocaleService }, { token: 'IceDataUrl' }], target: i0.ɵɵFactoryTarget.Injectable });
PageLabelsResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PageLabelsResolver, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PageLabelsResolver, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.TcmService }, { type: i2.LocaleService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['IceDataUrl']
                }] }]; } });

export { PageLabelsModule, PageLabelsResolver };
